const state = {
    Items: {
        data: [],
        total: 0,
        pages: {
            page: 1,
            totalPage: 1,
            limit: 100,
            filter: {
                /*service_category_abbr:"",
                equipment_type:"",
                location:"",
                equipment:"",
                work_description:"",
                frequency:"",
                planned_date:null,
                expiry_date:null,
                contractor:"",
                checklists:"",
                job_status:"",
                startDate:null,
                contract_id : '',
                endDate:null,
                between:{
                    startDate:null,
                    endDate:null,
                }*/
            }
        },
    },
    Loadings: {
        list: true,
        general: false,
        item: false,
        status: false,
    },
    contractId: 0,
    Item: null,
    requestJobList: {
        dataRequest: null,
        tabJob: null
    }
};

const getters = {
    Items: (state) => state.Items,
    Loadings: (state) => state.Loadings,
    contractId: (state) => state.contractId,
    Item: (state) => state.Item,
    RequestJobList:  (state) => state.requestJobList,
};

const actions = {
    async getJobItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/runsheet`, { params: params })
                .then(response => {
                    response.data.data.pages = params
                    resolve(response.data.data);
                })
                .catch(error => reject(error.response.data));
        });
    },
    async export({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/runsheet/export`, { params: params })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error.response.data));
        });
    },
    async getItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit('setLoadings', { key: "list", val: true });
            global.axios.get(`api/runsheet`, { params: params })
                .then(response => {
                    response.data.data.pages = params
                    commit('setLoadings', { key: "list", val: false });
                    if (!params.noComit) {
                        commit('setItems', response.data.data);
                    }
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async getItemsDueAndExpired({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit('setLoadings', { key: "list", val: true });
            global.axios.get(`api/runsheet`, { params: params })
                .then(response => {
                    response.data.data.pages = params
                    commit('setLoadings', { key: "list", val: false });
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async getItem({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit('setLoadings', { key: "item", val: true });
            global.axios.get(`api/runsheet/${params}`)
                .then(response => {
                    response.data.data.pages = params
                    commit('setLoadings', { key: "item", val: false });
                    commit('setItem', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error.response.data));
        });
    },
    async generalItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            let contract_id = params.contract_id;
            let maintenance_id = params.maintenance_id;
            commit('setLoadings', { key: "general", val: true });
            global.axios.post(`/api/contracts/${contract_id}/maintenance/${maintenance_id}/runsheet`, {
                    ids: params.ids,
                    supplier_id: params.supplier_id,
                    supplier: params.supplier,
                    raise_work_order: params.raise_work_order || false,
                    staff_in_charge_id: params.staff_in_charge_id || null,
                    staff_in_charge_name: params.staff_in_charge_name || null,
                    team_in_charge_id: params.team_in_charge_id || null,
                    team_in_charge_name: params.team_in_charge_name || null
                })
                .then(response => {
                    commit('setLoadings', { key: "general", val: false });
                    //Reset Item
                    commit('initJoblist', null);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async assignRunsheetSupplier({ commit }, params) {
        return new Promise((resolve, reject) => {
            var data =  {
                runsheet_ids: JSON.stringify(params.ids || []),
                generate_order: params.generate_order || false,
                filter: params.filter
            };
            if(params.supplier) {
                data.supplier_id = params.supplier.id;
                data.supplier = params.supplier.name;
            }
            if(params.staff_in_charge_id) data.staff_in_charge_id = params.staff_in_charge_id;
            if(params.staff_in_charge_name) data.staff_in_charge_name = params.staff_in_charge_name;
            if(params.team_in_charge_id) data.team_in_charge_id = params.team_in_charge_id;
            if(params.team_in_charge_name) data.team_in_charge_name = params.team_in_charge_name;

            global.axios(`api/runsheet/assign`, {
                    method: "PUT",
                    data: data,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('assignRunsheetSupplier', params);
                    resolve(response)
                })
                .catch(error => reject(error))
        });
    },
    async changeJobStatus({ commit }, params) {
        commit('setLoadings', { key: "status", val: true });
        return new Promise((resolve, reject) => {
            global.axios(`api/runsheet/status`, {
                    method: "PUT",
                    data: {
                        ids: JSON.stringify(params.ids || []),
                        job_status: params.job_status,
                        filter: params.filter
                    },
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response.data.data);
                    commit('setLoadings', { key: "status", val: false });
                })
                .catch(error => reject(error.response.data))
        });
    },
    async searchSupplier({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/users-search`, {
                    method: "GET",
                    params: {
                        filter: params,
                        limit: 1000
                    },
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => reject(error))
        });
    },
    async updateRemarks({ commit }, params) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            for (var i = 0; i < params.action.photos.length; i++) {
                let photo = params.action.photos[i];
                formData.append('photos[' + i + ']', photo);
            }
            if (params.data.description == null)
                params.data.description = '';
            formData.append('description', params.data.description);
            formData.append('remark_type', params.data.remark_type);
            if(params.isfollowUp) formData.append('isfollowUp', params.isfollowUp);
            global.axios(`/api/runsheet/remarks/${params.id}`, {
                    method: "POST",
                    data: formData,
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    let data = {};
                    if (params.data.remark_type == 'JobActionTaken') {
                        data.job_action_taken_id = response.data.data.action_taken.id;
                        data.action_taken = response.data.data.action_taken;
                    } else {
                        data.job_work_finding_id = response.data.data.work_finding.id;
                        data.work_finding = response.data.data.work_finding;
                    }
                    commit('updateRemarkOder', data)
                    resolve(response);

                })
                .catch(error => reject(error));
        });
    },
    async updateRunsheet({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/runsheet/${params.id}`, {
                    method: "PUT",
                    data: params.data,
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    commit('updateRemarkOder', response.data.data)
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async reScheduledRunsheet({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/runsheet/rescheduled`, {
                    method: "PUT",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    deleteRunsheet({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/runsheet`, {
                    method: "DELETE",
                    data: { ids: params.ids },
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async updatePlannedDateRunsheet({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/runsheet/planned-date/${params.id}`, {
                    method: "POST",
                    data: params.data,
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    //commit('updateRemarkOder', response.data.data)
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async deleteAttachments({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/attachments`, {
                    method: "DELETE",
                    data: { ids: params.ids },
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    commit('deleteAttachments', params)
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    deleteAttachmentsFollowUp({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/attachments`, {
                    method: "DELETE",
                    data: { ids: params.ids },
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    // commit('deleteAttachmentsFollowUp', params)
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getCheckListCalculated({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/checklist-entries/calculated/${params.id}`, {
                    method: "GET",
                    params: params.data,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => reject(error))
        });
    },
    async reportJob({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/equipment/report`, {
                    method: "POST",
                    responseType: 'blob',
                    data: {
                        ids: params.id,
                        mutil_file: params.mutil_file,
                        format_type: params.format_type,
                    },
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => reject(error))
        });
    },
    async reportJobBCA({ commit }, params) {
        return new Promise((resolve, reject) => {
          global.axios.post(`/api/joblist/report-bca`, params,{
            responseType: 'blob',
            headers: {
              Accept: "application/json",
            }
          })
                .then(response => {
                    resolve(response)
                })
                .catch(error => reject(error))
        });
    },
    async reportJobSummary({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/runsheet/report/${params.id}`, {
                    method: "GET",
                    params: {
                        type: params.type || ''
                    },
                    responseType: 'blob',
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => reject(error))
        });
    },
    async getUserLocationJob({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/users/location`, {
                    method: "GET",
                    params: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    /* 4023 */
    async checkBeforeGenerateJobAndOrder({ commit }, ids) {
        return new Promise((resolve, reject) => {
            global.axios.post(`/api/joblist/check-before-generate-job-and-order`, {
                ids: ids
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        });
    },
    async regenerateReport({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/runsheet/regenerate-report/${params}`)
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async generateSafetyInspectionReport({ commit }, id) {
        commit('setLoadings', { key: "detail", val: true });
        return new Promise((resolve, reject) => {
            global.axios(`api/runsheet/safety-inspection-report/${id}`, {
                method: "GET",
                responseType: 'blob',
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                commit('setLoadings', { key: "detail", val: false });
                resolve(response);
            })
            .catch(error => {
                commit('setLoadings', { key: "detail", val: false });
                reject(error)
            });
        });
    },
};

const mutations = {
    setItems(state, data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit);
        state.Items.data = data.items;
        state.Items.total = data.total;
        state.Items.pages = data.pages;
    },
    setTotalItems(state, data) {
        state.Items.total = data;
    },
    setLoadings(state, data) {
        state.Loadings[data.key] = data.val;
    },
    setcontractId(state, val) {
        state.contractId = val;
    },
    setItemsByContractId(state, data) {
        if (data && data.id != state.Items.pages.filter.contract_id) {
            state.Items.total = 0;
            state.Items.pages.filter.contract_id = data.id;
        }
    },
    setItem(state, data) {
        state.Item = data;
    },
    initJoblist(state, data) {
        state.Items.data = [];
        state.Items.total = 0;
    },
    assignRunsheetSupplier(state, data) {
        state.Items.data = state.Items.data.filter(function(obj) {
            if (data.ids.indexOf(obj.id) >= 0) {
                obj.supplier = data.supplier.name;
                obj.supplier_id = data.supplier.id
            }
            return obj
        });
    },
    updateFollowUp(state, data) {
        state.Item.checklists = data.checklists;
        state.Item = JSON.parse(JSON.stringify(state.Item));
    },
    updateRemarkOder(state, data) {
        state.Item = {...state.Item, ...data };
    },
    deleteAttachments(state, data) {
        if (data.action == 'action_taken') {
            state.Item.action_taken.attachments = state.Item.action_taken.attachments.filter(img => !data.ids.includes(img.id))
        } else {
            state.Item.work_finding.attachments = state.Item.work_finding.attachments.filter(img => !data.ids.includes(img.id))
        }
    },
    deleteAttachmentsFollowUp(state, data) {
        state.Item.checklists.content_checklist[data.key_of_list].follow_up.attachments = state.Item.checklists.content_checklist[data.key_of_list].follow_up.attachments.filter(img => img.id != data.ids[0])
    },
    setRequestJobList(state, data) {
        state.requestJobList = data;
    }

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
